module.exports = __webpack_public_path__ + "img/roi_high-profile_infrastructure.f756790c.jpg";